import { useContext } from "react";
import { UiContextState } from "../providers/AudioProvider/uiStateProvider";

export const useUiAudioStateContext = () => {
    return useContext(UiContextState);
};
